import { z } from 'zod';
import {
  CHECK_TYPES,
  DEFINITION_SOURCES,
} from '@internal/backstage-plugin-pulse-common';

export const checkResultSchema = z.object({
  checkId: z.string(),
  name: z.string(),
  type: z.enum(CHECK_TYPES),
  passed: z.boolean(),
  message: z.string().optional(),
  fetchedAt: z.string().optional(),
});

export const checkDefinitionSchema = z.object({
  id: z.string(),
  ownerEntityRef: z.string(),
  name: z.string(),
  description: z.string().optional(),
  type: z.enum(CHECK_TYPES),
  pathResolver: z.string(),
  rule: z.record(z.string(), z.unknown()),
  sensitiveFacts: z.array(z.string()).optional(),
  filter: z.array(z.record(z.string(), z.unknown())).optional(),
  exclude: z.array(z.record(z.string(), z.unknown())).optional(),
  failedMessage: z.string().optional(),
  passedMessage: z.string().optional(),
  createdAt: z.iso.datetime({ offset: true }).optional(),
  updatedAt: z.iso.datetime({ offset: true }).optional(),
  source: z.enum(DEFINITION_SOURCES).optional(),
});

export const checksResponseSchema = z.object({
  checks: z.array(checkDefinitionSchema).default([]),
});

export const checkImportResultSchema = z.object({
  total: z.number().int().nonnegative(),
  imported: z.array(z.string()),
  skipped: z.array(z.string()),
  failed: z.array(
    z.object({
      id: z.string().optional(),
      reason: z.string(),
    }),
  ),
});

export const checkResultsResponseSchema = z.object({
  checkId: z.string(),
  checkName: z.string(),
  results: z.array(
    z.object({
      entityRef: z.string(),
      checkResult: checkResultSchema,
    }),
  ),
  excludedEntityRefs: z.array(z.string()).optional().default([]),
});

export const entityCheckResultsResponseSchema = z.object({
  results: z.array(checkResultSchema),
});

export const manualCheckResultResponseSchema = z.object({
  result: checkResultSchema.omit({ fetchedAt: true }).extend({
    type: z.literal('manual'),
  }),
  justification: z.string(),
  setByUserEntityRef: z.string(),
  updatedAt: z.string(),
});

export const checkExemptionResponseSchema = z.object({
  checkId: z.string(),
  entityRef: z.string(),
  justification: z.string(),
  setByUserEntityRef: z.string(),
  updatedAt: z.string(),
});

export const entityCheckExemptionsResponseSchema = z.object({
  exemptions: z.array(checkExemptionResponseSchema),
});

export const checkHistoryPointSchema = z.object({
  date: z.string(),
  passed: z.number(),
  failed: z.number(),
});

export const checkHistoryResponseSchema = z.object({
  checkId: z.string(),
  history: z.array(checkHistoryPointSchema),
});

export const resolvedValueSchema = z.object({
  factRef: z.string(),
  path: z.string(),
  value: z.unknown(),
  sensitive: z.boolean(),
});

export const resolvedValuesResponseSchema = z.object({
  resolvedValues: z.array(resolvedValueSchema),
});
